module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var house = Util.clone(value);

if (house.type == Glonass.BuildingType.Unknown) {
	delete house.type;
}

Util.String.titleIf(house, {
	type: Glonass.BuildingType
});

card.encode(house, { type: "тип ", floors: "этажей ", people: "людей "}, mode);


    ; __append("\n\n")
    ; __append(escapeFn( Util.String.join([house.type, house.floors, house.people]) ))
    ; __append("\n")
  }
  return __output.join("");

}